import React from 'react'
import { GItem } from '../../common/grids'
import FieldTitle from './common/fieldTitle'
import { Select } from '../../common/inputs/select'
import { Flag, facilityInputFieldType } from '../../../../containers/common/constant/classification'
import TextField from './common/textField'

export interface FacilityInputFieldProps {
    childNum: number
    id: string
    label: string,
    options: string[]
    inputType: string
    mustFlag: string
}
const FacilityinputField: React.FC<FacilityInputFieldProps> = (props) => {
    const { childNum, label, options, inputType, mustFlag, id } = props

    const option = options.filter(option => option !== null).map((option, index) => ({
        label: option, value: String(index + 1)
    }))
    option.unshift({
        label: '　',
        value: '',
    })

    const inputName = `children.${childNum}.facilityInputFields.${id}.answer`

    return (
        <GItem xs={12}>
            <FieldTitle
                title={label}
                required={mustFlag === Flag.ON}
            />
            {
                inputType === facilityInputFieldType.select && (
                    <GItem xs={12}>
                        <Select
                            name={inputName}
                            fullWidth
                            label={label}
                            valueLabels={option}
                            required={mustFlag === Flag.ON}
                            />
                    </GItem>
                )
            }
            {
                inputType === facilityInputFieldType.text && (
                    <GItem xs={12}>
                    <TextField 
                        name={inputName}
                        label={label}
                        maxLength={500} 
                        minRows={2}
                        required={mustFlag === Flag.ON}
                        isSubField
                    />
                    </GItem>
                )
            }
        </GItem>
    )
}

export default FacilityinputField
